export default __webpack_public_path__ + "static/media/stamp2.92c0db27.mp3";